import React from 'react';
import PropTypes from 'prop-types';

import Blokkendoos from '../../services/blokkendoos';
import { META_TAGS } from '../../services/constants';

import styles from './IsolationHeader.module.scss';

function IsolationHeader({ setUserFlow }) {
  const handleUserFlowChange = ({ target: { value } }) => {
    let $meta = document.querySelector(
      Blokkendoos.makeMetaSelector(META_TAGS.SIGNUP_FOR)
    );
    if (!$meta) {
      $meta = document.createElement('meta');
      $meta.setAttribute('name', META_TAGS.SIGNUP_FOR);
      document.head.appendChild($meta);
    }

    $meta.setAttribute('content', value);

    setUserFlow(value);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.description}>
        <h2>Isolated Mode</h2>
        <p>
          This app is running in isolated mode. That means there is no
          connection with API services. All data is mocked. Nothing will be
          submitted/uploaded.
        </p>
      </div>
      <div>
        <label htmlFor='IsolationUserFlow' className={styles.userFlowLabel}>
          User flow
        </label>
        <select id='IsolationUserFlow' onChange={handleUserFlowChange}>
          <option value='university'>University</option>,
          <option value='candidate'>Candidate</option>,
          <option value='cvbuilder'>CV builder</option>,
          <option value='apply'>Apply</option>,
          <option value='summerjob'>Summer job</option>,
          <option value='candidateIndeed'>Candidate (Indeed)</option>,
          <option value='applyIndeed'>Apply (Indeed)</option>,
          <option value='cvbuilderIndeed'>CV builder (Indeed)</option>,
          <option value='universityIndeed'>University (Indeed)</option>,
          <option value='summerjobIndeed'>Summer job (Indeed)</option>
        </select>
      </div>
    </div>
  );
}

IsolationHeader.propTypes = {
  setUserFlow: PropTypes.func.isRequired
};

export default IsolationHeader;
